import i18n from 'i18next';
import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { subDomain } from 'api/ApiMethods';
import logo from 'assets/images/welcomepagelogo.svg';
import logoText from 'assets/images/TAG-logo-text.svg';
import SaylogoText from 'assets/images/saysomething_logo.png';
import { Link } from 'react-router-dom';
import langKey from 'i18n/keys';

function WelcomePage() {
  const [orgId, setOrgId] = useState(null);
  const [orgLogo, setOrgLogo] = useState(null);
  const [isLoadingLogo, setIsLoadingLogo] = useState(true);

  useEffect(() => {
    localStorage.removeItem('orgKey');
    // subDomain()
    subDomain()
      .then((res) => {
        const data = res?.data ?? [];
        const sub = localStorage.getItem('orgKey');
        const org = data.find((o) => o.sub_domain === sub);
        if (!org) {
          setIsLoadingLogo(false);
          return;
        }

        localStorage.setItem('orgId', org.id);
        setOrgId(org.id);

        if (org.logo) {
          const logoUrl = org.logo.startsWith('http')
            ? org.logo
            : `${process.env.REACT_APP_API_BASE_URL.replace(
                /\/$/,
                ''
              )}/${org.logo.replace(/^\//, '')}`;

          const img = new Image();
          img.onload = () => {
            setOrgLogo(logoUrl);
            setIsLoadingLogo(false);
          };
          img.onerror = () => {
            console.warn(
              'Org logo failed to load. Falling back to default logo.'
            );
            setOrgLogo(null);
            setIsLoadingLogo(false);
          };
          img.src = logoUrl;
        } else {
          setIsLoadingLogo(false);
        }
      })
      .catch((err) => {
        console.error('Error fetching subdomain data:', err);
        setIsLoadingLogo(false);
      });
  }, []);
  const hideLogo = { visibility: isLoadingLogo ? 'hidden' : 'visible' };

  return (
    <div className="welcome-page">
      {/* <div className="t-bg-faint-blue logo_parent_div"> */}
      <div
        className={`logo_parent_div ${
          orgLogo ? 'bg-white' : 't-bg-faint-blue'
        }`}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexGrow: 1,
              justifyContent: {
                xs: 'start',
                md: 'center',
                lg: 'center',
                xl: 'center'
              },
              alignItems: 'center',
              height: '100%',
              paddingY: '5rem',
              ...hideLogo
            }}
          >
            {orgLogo ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <img
                  src={orgLogo}
                  className="welcome-page-logo1"
                  alt="TAG logo"
                  style={{ width: '40%', height: '100px', marginTop: '20px' }}
                  onError={(e) => {
                    console.warn(
                      'Org logo failed at render. Reverting to default.'
                    );
                    e.target.onerror = null;
                    setOrgLogo(null);
                  }}
                />
                <img
                  src={orgLogo}
                  className="welcome-page-logo-mobile"
                  alt="TAG logo mobile"
                  onError={(e) => {
                    console.warn(
                      'Org logo failed at render. Reverting to default.'
                    );
                    e.target.onerror = null;
                    setOrgLogo(null);
                  }}
                />
                <img
                  src={SaylogoText}
                  className="saysomething"
                  alt="TAG logo mobile"
                  style={{ width: '80%', marginTop: '20px' }}
                />
              </Box>
            ) : (
              <>
                <img
                  src={logoText}
                  className="welcome-page-logo"
                  alt="TAG logo"
                />
                <img
                  src={logo}
                  className="welcome-page-logo-mobile1"
                  alt="TAG logo mobile"
                />
              </>
            )}
          </Box>
        </Box>
      </div>

      {orgId ? (
        <div className="div-padding">
          <Grid container>
            <div>
              <h1 className="mobile-h1-font">
                <strong>{i18n.t(langKey.welcome)}</strong>
              </h1>
              <h1 className="mobile-h1-font">{i18n.t(langKey.here_to_help)}</h1>
            </div>
            <Grid
              item
              md={6}
              xs={12}
              sx={{ paddingBottom: '0 !important' }}
              className="welcome-page-margin-auto"
            >
              <div className="welcome-page-new-button t-bg-faint-blue">
                <Link to="introduction" className="life-ring-text">
                  {i18n.t(langKey.file_new_report)}
                </Link>
              </div>
              {/* Start Add new report Button for mobile screen  */}
              <div className="mobile-button-div">
                <div className="new-button">
                  <Link to="introduction">
                    {i18n.t(langKey.file_new_report)}
                  </Link>
                </div>
              </div>
              {/* End Add new report Button for mobile screen  */}
            </Grid>

            <Grid
              item
              md={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '2rem !important',
                overflow: 'hidden'
              }}
            >
              <div className="welcome-page-update-button t-bg-faint-blue">
                <Link className="new-report" to="report-id">
                  {i18n.t(langKey.add_to_existing)}
                </Link>
              </div>
              <div className="add-button-div">
                <div className="add-button">
                  <Link to="report-id">{i18n.t(langKey.add_to_existing)}</Link>
                </div>
              </div>
              <hr className="divider welcome-page-divider" />
              <div className="welcome-page-update-button t-bg-faint-blue">
                <Link className="new-report" to="review-id">
                  {i18n.t(langKey.review_case_status)}
                </Link>
              </div>
              <div className="add-button-div">
                <div className="add-button">
                  <Link to="review-id">
                    {i18n.t(langKey.review_case_status)}
                  </Link>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexGrow: 1,
              justifyContent: {
                xs: 'start',
                md: 'center',
                lg: 'center',
                xl: 'center'
              },
              alignItems: 'center',
              height: '100%',
              paddingY: '5rem'
            }}
          >
            <div className="h1-fontsize-80">
              {i18n.t(langKey.landingpage_selectdomain)}
            </div>
          </Box>
        </Box>
      )}
    </div>
  );
}

export default WelcomePage;
